<template>
    <v-select
        :items="items"
        :loading="loading"
        :value="value"
        :error-messages="[...errors, ...errorMessages]"
        :hide-details="hideDetails"
        v-bind="$attrs"
        @input="$emit('input', $event)"
        >
    </v-select>
</template>

<script>
import { getCustomerSites } from './../../services/sales/site';

export default {
    name: "CustomerSitesSelect",
    props: {
        customerId: [String, Number],
        value: [String, Number],
        errorMessages: {
            default: () => [],
            type: Array
        },
        hideDetails: String
    },
    data() {
        return {
            items: [],
            loading: false,
            errors: []
        }
    },
    watch: {
        customerId(val) {
            this.clearItems();
            this.clearErrors();
            if(!val) return;
            this.fetchCustomerSites(val);
        }
    },
    methods: {
        async fetchCustomerSites(customerId) {
            try {
                this.loading = true;
                let resp = await getCustomerSites(customerId);
                this.items = resp.data;
                this.loading = false;
                this.handleEmptySiteData(resp);
            } catch (error) {
                this.setError(this.extractErrorMessage(error));
                this.loading = false;
            }
        },
        clearErrors() {
            this.errors = [];
        },
        setError(error) {
            this.errors.push(error);
        },
        clearItems() {
            this.items = [];
        },
        handleEmptySiteData(resp) {
            if(resp.data.length === 0) this.setError("Customer doesn't has any sites!"); 
        },
        extractErrorMessage(error) {
            return error.response ? error.response.data.message : error;
        }
    },
    mounted() {
        if(this.value) {
            this.fetchCustomerSites(this.customerId);
        }
    }
}
</script>

<style>

</style>